module.exports = __webpack_public_path__ + "static/media/myaccount.e6fadbb7.png";